import { createAction } from "@reduxjs/toolkit";
import * as types from "../types/actions";

export const login = createAction(types.RENTAL_LOGIN);
export const logout = createAction(types.RENTAL_LOGOUT);
export const updateReturnDate = createAction(types.UPDATE_RETURN_DATE);
